/*
  MAIN.JS — COCINEXA

  IMPORTANTE: este archivo es un asset estatico. Shopify NO procesa Liquid
  aqui. Toda la configuracion (rutas y textos traducidos) llega desde
  layout/theme.liquid a traves de window.Cocinexa.
  Ver AUDIT_PHASE_8_RECOVERY.md §8.
*/

(function () {
  'use strict';

  var config = window.Cocinexa || {};
  var routes = config.routes || {};
  var strings = config.strings || {};

  var SECTION_CART_DRAWER = 'cart-drawer';

  /* =======================================================================
     Anuncios para lector de pantalla (WCAG 2.2 SC 4.1.3)
     -----------------------------------------------------------------------
     El contenido que cambia sin recargar la pagina no llega a quien navega
     con lector de pantalla: el carrito y la busqueda predictiva cambiaban en
     silencio. Se escriben en una unica region role="status" del layout.

     Los ERRORES no pasan por aqui: ya tienen su role="alert" junto al campo.
     ======================================================================= */

  var a11yStrings = (window.Cocinexa && window.Cocinexa.a11y) || {};

  function announce(message) {
    var region = document.getElementById('A11yStatus');
    if (!region || !message) return;

    // Un mensaje identico al que ya hay no se vuelve a anunciar. Se vacia y se
    // reescribe en el siguiente frame para forzar la lectura.
    region.textContent = '';
    window.requestAnimationFrame(function () {
      region.textContent = message;
    });
  }

  // Sustituye el marcador del contador por la cifra real.
  function withCount(template, count) {
    if (!template) return '';
    return template.replace('[[n]]', String(count));
  }

  /* =======================================================================
     Utilidades
     ======================================================================= */

  function qs(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  /* =======================================================================
     Drawer — apertura, cierre, overlay, Escape y gestion de foco
     ======================================================================= */

  var FOCUSABLE = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled])',
    'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  var Drawer = {
    active: null,
    lastFocused: null,

    open: function (drawer, trigger) {
      if (!drawer || drawer === Drawer.active) return;
      if (Drawer.active) Drawer.close(Drawer.active);

      Drawer.lastFocused = trigger || document.activeElement;
      Drawer.active = drawer;

      drawer.classList.add('is-open');
      document.body.classList.add('is-scroll-locked');

      qsa('[aria-controls="' + drawer.id + '"]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'true');
      });

      // El foco entra en el panel para que el teclado no quede detras del overlay.
      var focusTarget = qs(FOCUSABLE, drawer);
      if (focusTarget) focusTarget.focus();
    },

    close: function (drawer) {
      drawer = drawer || Drawer.active;
      if (!drawer) return;

      drawer.classList.remove('is-open');
      document.body.classList.remove('is-scroll-locked');

      qsa('[aria-controls="' + drawer.id + '"]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });

      if (Drawer.active === drawer) Drawer.active = null;

      // El foco vuelve al boton que abrio el drawer.
      if (Drawer.lastFocused && document.contains(Drawer.lastFocused)) {
        Drawer.lastFocused.focus();
      }
      Drawer.lastFocused = null;
    },

    trapFocus: function (event) {
      if (!Drawer.active || event.key !== 'Tab') return;

      var panel = qs('.drawer__panel', Drawer.active);
      if (!panel) return;

      var items = qsa(FOCUSABLE, panel).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  function initDrawerEvents() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-cart-toggle], [data-menu-toggle]');
      if (toggle) {
        event.preventDefault();
        var id = toggle.getAttribute('aria-controls');
        Drawer.open(document.getElementById(id), toggle);
        return;
      }

      if (event.target.closest('[data-drawer-close]') || event.target.closest('[data-drawer-overlay]')) {
        event.preventDefault();
        Drawer.close(event.target.closest('.drawer'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && Drawer.active) {
        event.preventDefault();
        Drawer.close();
        return;
      }
      Drawer.trapFocus(event);
    });
  }

  /* =======================================================================
     Submenus de la navegacion

     Se apoyan en <details>, asi que abrir, cerrar, aria-expanded y el manejo
     de teclado ya son nativos. Aqui solo se anade lo que el elemento no cubre
     por si mismo: cerrar al pulsar Escape y al clicar fuera, y que no queden
     dos submenus abiertos a la vez.
     ======================================================================= */

  function initNavDropdowns() {
    document.addEventListener('click', function (event) {
      var open = qsa('[data-nav-dropdown][open]');
      if (!open.length) return;

      var inside = event.target.closest('[data-nav-dropdown]');
      open.forEach(function (item) {
        if (item !== inside) item.removeAttribute('open');
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      var open = qsa('[data-nav-dropdown][open]');
      if (!open.length) return;

      // El foco vuelve al enlace que abrio el submenu.
      open.forEach(function (item) {
        item.removeAttribute('open');
        var summary = qs('summary', item);
        if (summary && item.contains(document.activeElement)) summary.focus();
      });
    });
  }

  /* =======================================================================
     Buscador del header
     ======================================================================= */

  function initSearch() {
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('[data-search-toggle]');
      if (!toggle) return;

      event.preventDefault();
      var panel = qs('[data-search-panel]');
      if (!panel) return;

      var willOpen = panel.hasAttribute('hidden');
      if (willOpen) {
        panel.removeAttribute('hidden');
        var input = qs('[data-search-input]', panel);
        if (input) input.focus();
      } else {
        panel.setAttribute('hidden', '');
      }

      qsa('[data-search-toggle][aria-controls]').forEach(function (button) {
        button.setAttribute('aria-expanded', String(willOpen));
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var panel = qs('[data-search-panel]');
      if (!panel || panel.hasAttribute('hidden')) return;

      panel.setAttribute('hidden', '');
      qsa('[data-search-toggle][aria-controls]').forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      });
    });
  }

  /* =======================================================================
     Carrito — Cart AJAX API + Section Rendering API
     ======================================================================= */

  var Cart = {
    busy: false,

    setBusy: function (state) {
      Cart.busy = state;
      qsa('[data-cart-drawer], [data-cart-page]').forEach(function (node) {
        node.classList.toggle('is-busy', state);
      });
    },

    showError: function (message) {
      var text = message || strings.cartUpdateError || strings.genericError || '';
      var page = qs('[data-cart-page] [data-cart-error]');
      var drawer = qs('[data-cart-drawer] [data-cart-error]');
      [page, drawer].forEach(function (target) {
        if (!target) return;
        target.textContent = text;
        target.hidden = false;
      });
    },

    // Vuelve a renderizar con la Section Rendering API el drawer y, si el
    // usuario esta en la pagina de carrito, tambien esa seccion. Ambas en una
    // sola peticion mediante el parametro ?sections=
    refresh: function () {
      var ids = [SECTION_CART_DRAWER];
      var page = qs('[data-cart-page]');
      var pageId = page ? page.getAttribute('data-section-id') : null;
      if (pageId && ids.indexOf(pageId) === -1) ids.push(pageId);

      var url = routes.cart + '?sections=' + ids.join(',');

      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Section render failed');
          return response.json();
        })
        .then(function (sections) {
          if (sections[SECTION_CART_DRAWER]) {
            Cart.replaceDrawer(sections[SECTION_CART_DRAWER]);
          }
          if (pageId && sections[pageId]) {
            Cart.replaceNode(sections[pageId], '[data-cart-page]');
          }
        })
        .then(Cart.updateCount);
    },

    parse: function (html) {
      return new DOMParser().parseFromString(html, 'text/html');
    },

    replaceNode: function (html, selector) {
      var fresh = qs(selector, Cart.parse(html));
      var current = qs(selector);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
    },

    // El drawer se actualiza por partes para no destruir el panel abierto ni
    // perder el foco que hay dentro.
    replaceDrawer: function (html) {
      var fresh = qs('[data-cart-drawer]', Cart.parse(html));
      var current = qs('[data-cart-drawer]');
      if (!fresh || !current) return;

      var freshBody = qs('[data-cart-body]', fresh);
      var currentBody = qs('[data-cart-body]', current);
      if (freshBody && currentBody) currentBody.innerHTML = freshBody.innerHTML;

      var freshFooter = qs('[data-cart-footer]', fresh);
      var currentFooter = qs('[data-cart-footer]', current);
      var panel = qs('.drawer__panel', current);

      if (freshFooter && currentFooter) {
        currentFooter.innerHTML = freshFooter.innerHTML;
      } else if (freshFooter && !currentFooter && panel) {
        panel.appendChild(freshFooter.cloneNode(true));
      } else if (!freshFooter && currentFooter) {
        currentFooter.remove();
      }
    },

    updateCount: function () {
      return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          // El nodo existe siempre en el DOM, tambien con el carrito vacio,
          // por lo que puede pasar de 0 a 1 y de 1 a 0. Ver AUDIT §13.
          qsa('[data-cart-count]').forEach(function (badge) {
            badge.textContent = cart.item_count;
            badge.hidden = cart.item_count === 0;
          });
          document.dispatchEvent(new CustomEvent('cocinexa:cart:updated', { detail: cart }));
        })
        .catch(function () { /* el contador no es critico */ });
    },

    add: function (formData, button) {
      var label = button ? qs('[data-add-button-text]', button) : null;
      var originalText = label ? label.textContent : '';

      if (button) {
        button.disabled = true;
        button.classList.add('is-loading');
      }
      if (label && strings.addingToCart) label.textContent = strings.addingToCart;

      return fetch(routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            // 422 = sin stock o variante invalida. Antes se trataba como exito.
            if (!response.ok) {
              var message = data.description || data.message || strings.addToCartError;
              throw new Error(message);
            }
            return data;
          });
        })
        .then(function () {
          if (label && strings.addedToCart) label.textContent = strings.addedToCart;
          // Confirmacion visible tambien en la accion compacta de la tarjeta,
          // que no muestra texto.
          if (button) button.classList.add('is-done');
          return Cart.refresh().then(function () {
            var drawer = qs('[data-cart-drawer]');
            Drawer.open(drawer, button);
          });
        })
        .catch(function (error) {
          var form = button ? button.closest('form') : null;
          var target = form ? qs('[data-form-error]', form) : null;
          if (target) {
            target.textContent = error.message || strings.addToCartError;
            target.hidden = false;
          } else {
            Cart.showError(error.message);
          }
        })
        .then(function () {
          window.setTimeout(function () {
            if (button) {
              button.disabled = false;
              button.classList.remove('is-loading', 'is-done');
            }
            if (label) label.textContent = originalText || strings.addToCart;
          }, 1400);
        });
    },

    change: function (line, quantity) {
      if (Cart.busy) return Promise.resolve();
      Cart.setBusy(true);

      return fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) throw new Error(strings.cartUpdateError);
          return response.json();
        })
        .then(function () { return Cart.refresh(); })
        .catch(function (error) { Cart.showError(error.message); })
        .then(function () { Cart.setBusy(false); });
    }
  };

  function initCartEvents() {
    // Anadir al carrito (ficha de producto y quick add de la tarjeta)
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-product-form]');
      if (!form) return;

      event.preventDefault();

      var error = qs('[data-form-error]', form);
      if (error) error.hidden = true;

      Cart.add(new FormData(form), qs('[data-add-button]', form));
    });

    document.addEventListener('click', function (event) {
      // Eliminar linea
      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        Cart.change(parseInt(remove.getAttribute('data-line'), 10), 0);
        return;
      }

      // Botones +/- de cantidad
      var step = event.target.closest('[data-quantity-change]');
      if (!step) return;

      event.preventDefault();
      var wrapper = step.closest('.quantity');
      var input = wrapper ? qs('input', wrapper) : null;
      if (!input) return;

      var delta = parseInt(step.getAttribute('data-quantity-change'), 10);
      var min = parseInt(input.getAttribute('min') || '0', 10);
      var next = Math.max(min, (parseInt(input.value, 10) || 0) + delta);
      input.value = next;

      var line = input.getAttribute('data-line');
      if (line) {
        // Esta dentro del carrito: se sincroniza con Shopify.
        Cart.change(parseInt(line, 10), next);
      } else {
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Edicion manual de la cantidad dentro del carrito
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-quantity]');
      if (!input) return;

      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      Cart.change(parseInt(input.getAttribute('data-line'), 10), quantity);
    });
  }

  /* =======================================================================
     Selector de variantes
     ======================================================================= */

  function initVariantSelectors(scope) {
    qsa('[data-product-form-wrapper]', scope || document).forEach(function (wrapper) {
      var dataNode = qs('[data-variant-data]', wrapper);
      var idInput = qs('[data-variant-id]', wrapper);
      if (!dataNode || !idInput) return;

      var variants;
      try {
        variants = JSON.parse(dataNode.textContent);
      } catch (error) {
        return;
      }

      // Fase 9: las opciones son grupos de radios, no <select>. Se agrupan por
      // el fieldset que las contiene, cuyo data-option-position da el orden.
      var groups = qsa('[data-option-position]', wrapper).sort(function (a, b) {
        return a.getAttribute('data-option-position') - b.getAttribute('data-option-position');
      });
      if (!groups.length) return;

      function chosenValues() {
        return groups.map(function (group) {
          var checked = qs('[data-product-option]:checked', group);
          return checked ? checked.value : null;
        });
      }

      function update() {
        var chosen = chosenValues();

        // Refleja el valor elegido junto al nombre de la opcion ("Color: Azul").
        groups.forEach(function (group, index) {
          var label = qs('[data-option-selected]', group);
          if (label && chosen[index] !== null) label.textContent = chosen[index];
        });

        var match = variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === chosen[index];
          });
        });

        var button = qs('[data-add-button]', wrapper);
        var label = qs('[data-add-button-text]', wrapper);

        // Precio: se muestra el bloque renderizado por Shopify para esa variante.
        qsa('[data-variant-price]', wrapper).forEach(function (node) {
          node.hidden = !match || node.getAttribute('data-variant-price') !== String(match.id);
        });

        if (!match) {
          // Combinacion inexistente: no se deja un id de variante antiguo en
          // el formulario ni un aviso de stock que ya no corresponde.
          idInput.value = '';
          idInput.disabled = true;
          if (button) button.disabled = true;
          if (label) label.textContent = strings.unavailable || '';
          qsa('[data-variant-inventory]').forEach(function (node) { node.hidden = true; });
          return;
        }

        idInput.value = match.id;
        idInput.disabled = false;

        if (button) button.disabled = !match.available;
        if (label) label.textContent = match.available ? strings.addToCart : strings.soldOut;

        // Disponibilidad: se muestra el aviso renderizado por Shopify para
        // esa variante concreta (stock real, sin urgencia inventada).
        qsa('[data-variant-inventory]').forEach(function (node) {
          node.hidden = node.getAttribute('data-variant-inventory') !== String(match.id);
        });

        // Si la variante tiene imagen propia, la galeria salta a ella.
        if (match.featured_media_id) {
          showGalleryMedia(String(match.featured_media_id));
        }

        // La URL refleja la variante seleccionada (compartir, recargar, analitica).
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      wrapper.addEventListener('change', function (event) {
        if (event.target.closest('[data-product-option]')) update();
      });
    });
  }

  /* =======================================================================
     Revelado al hacer scroll
     ======================================================================= */

  function initScrollReveal(scope) {
    var targets = qsa('[data-animate]', scope || document);
    if (!targets.length) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduced.matches || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* =======================================================================
     Vídeo del hero

     El markup deja el vídeo con preload="none" y sin autoplay. Aquí se decide
     si reproducirlo, cuál reproducir y cuándo mostrarlo. Tres cosas que el
     HTML nativo no puede resolver solo:

       1. prefers-reduced-motion. Con el atributo autoplay el vídeo arranca
          antes de que ningún script pueda evitarlo. Aquí simplemente no se
          reproduce y se queda la imagen de respaldo.
       2. Vídeo de móvil y de escritorio. Con autoplay en ambos el navegador
          descargaría los dos, aunque CSS oculte uno.
       3. Fundido de entrada. Sin saber cuándo hay primer fotograma, el <video>
          pinta un rectángulo negro sobre la imagen.

     Si este módulo no llega a ejecutarse, el hero se queda con la imagen: no
     hay estado roto posible.
     ======================================================================= */

  function initHeroVideo() {
    var media = qs('.hero__media');
    if (!media) return;

    var videos = qsa('.hero__video', media);
    if (!videos.length) return;

    // Respeta la preferencia del sistema, y reacciona si cambia en caliente.
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    function visibleVideo() {
      return videos.filter(function (video) {
        return video.offsetParent !== null;
      })[0];
    }

    function stopAll() {
      videos.forEach(function (video) {
        video.pause();
        video.classList.remove('is-ready');
      });
    }

    function start() {
      if (reduced.matches) { stopAll(); return; }

      var video = visibleVideo();
      if (!video) return;

      // Los demás se detienen: solo suena, y solo carga, el visible.
      videos.forEach(function (other) {
        if (other !== video) { other.pause(); other.classList.remove('is-ready'); }
      });

      if (!video.dataset.ready) {
        video.dataset.ready = '1';
        video.addEventListener('canplay', function () {
          video.classList.add('is-ready');
        });
      }

      video.preload = 'auto';
      var attempt = video.play();

      // Si el navegador rechaza la reproducción automática, se queda la
      // imagen. No se insiste ni se muestra ningún control.
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () { video.classList.remove('is-ready'); });
      }
    }

    // Solo se carga cuando el hero está a la vista. En la portada eso es de
    // inmediato, pero evita descargar el vídeo si la sección se usa más abajo.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { start(); } else { stopAll(); }
        });
      }, { threshold: 0.1 });
      observer.observe(media);
    } else {
      start();
    }

    reduced.addEventListener('change', function () {
      if (reduced.matches) { stopAll(); } else { start(); }
    });

    // Al cambiar de breakpoint hay que pasar al otro vídeo.
    window.matchMedia('(min-width: 750px)').addEventListener('change', start);
  }

  /* =======================================================================
     Galeria de producto
     ======================================================================= */

  function showGalleryMedia(mediaId) {
    var gallery = qs('[data-product-gallery]');
    if (!gallery) return;

    var found = false;
    qsa('[data-gallery-item]', gallery).forEach(function (item) {
      var match = item.getAttribute('data-media-id') === mediaId;
      item.hidden = !match;
      if (match) found = true;

      // Un video que deja de verse se pausa.
      if (!match) {
        var video = qs('video', item);
        if (video && !video.paused) video.pause();
      }
    });

    if (!found) return;

    qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      thumb.setAttribute('aria-current', String(thumb.getAttribute('data-media-id') === mediaId));
    });
  }

  function initProductGallery(scope) {
    qsa('[data-product-gallery]', scope || document).forEach(function (gallery) {
      gallery.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        event.preventDefault();
        showGalleryMedia(thumb.getAttribute('data-media-id'));
      });

      // Flechas izquierda/derecha entre miniaturas.
      gallery.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        var thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;

        var thumbs = qsa('[data-gallery-thumb]', gallery);
        var index = thumbs.indexOf(thumb);
        var next = event.key === 'ArrowRight' ? index + 1 : index - 1;
        if (next < 0 || next >= thumbs.length) return;

        event.preventDefault();
        thumbs[next].focus();
        showGalleryMedia(thumbs[next].getAttribute('data-media-id'));
      });
    });
  }

  /* =======================================================================
     Barra fija de compra (movil)
     ======================================================================= */

  function initStickyAtc() {
    var bar = qs('[data-sticky-atc]');
    // Acotado al formulario principal de la ficha: las tarjetas de productos
    // relacionados tambien tienen [data-product-form] (quick add).
    var form = qs('[data-product-form-wrapper] [data-product-form]');
    if (!bar || !form) return;

    var button = qs('[data-sticky-atc-button]', bar);
    var realButton = qs('[data-add-button]', form);
    if (!button || !realButton) return;

    // El boton fijo NO envia un formulario propio: dispara el real, asi que
    // siempre manda la variante y la cantidad que el usuario ha elegido.
    button.addEventListener('click', function () {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(realButton);
      } else {
        realButton.click();
      }
    });

    // Aparece cuando el boton real deja de verse.
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.hidden = entry.isIntersecting;
      });
    }, { threshold: 0 });

    observer.observe(realButton);

    // El estado del boton fijo sigue al del boton real.
    var sync = new MutationObserver(function () {
      button.disabled = realButton.disabled;
    });
    sync.observe(realButton, { attributes: true, attributeFilter: ['disabled'] });
  }

  /* =======================================================================
     Productos relacionados (Product Recommendations API de Shopify)
     ======================================================================= */

  function initRecommendations() {
    var container = qs('[data-related-products]');
    if (!container || !('IntersectionObserver' in window)) return;

    var url = container.getAttribute('data-url');
    if (!url) return;

    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();

      // Carga diferida: no compite con el LCP de la ficha.
      fetch(url)
        .then(function (response) {
          if (!response.ok) throw new Error('recommendations failed');
          return response.text();
        })
        .then(function (html) {
          var fresh = qs('[data-related-products]', new DOMParser().parseFromString(html, 'text/html'));
          if (!fresh) return;
          container.innerHTML = fresh.innerHTML;
          initScrollReveal(container);
        })
        .catch(function () { /* sin recomendaciones no pasa nada */ });
    }, { rootMargin: '400px 0px' });

    observer.observe(container);
  }

  /* =======================================================================
     Busqueda predictiva (Section Rendering API de Shopify)
     ======================================================================= */

  function initPredictiveSearch() {
    var input = qs('[data-search-input]');
    var results = qs('[data-predictive-results]');
    if (!input || !results || !routes.predictiveSearch) return;

    var timer = null;
    var controller = null;

    function hide() {
      results.hidden = true;
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
    }

    function run(term) {
      if (controller) controller.abort();
      controller = new AbortController();

      var url = routes.predictiveSearch +
        '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (response) {
          if (!response.ok) throw new Error('predictive search failed');
          return response.text();
        })
        .then(function (html) {
          var fresh = qs('.predictive', new DOMParser().parseFromString(html, 'text/html'));
          if (!fresh) { hide(); return; }
          results.innerHTML = fresh.outerHTML;
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');

          // Sin esto, los resultados aparecen en silencio para el lector.
          var found = qsa('.predictive__item', results).length;
          announce(found > 0
            ? withCount(a11yStrings.resultsCount, found)
            : a11yStrings.noResults);
        })
        .catch(function (error) {
          if (error.name !== 'AbortError') hide();
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      window.clearTimeout(timer);

      if (term.length < 2) { hide(); return; }
      timer = window.setTimeout(function () { run(term); }, 250);
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') hide();
    });

    // Cerrar al hacer clic fuera del panel de busqueda.
    document.addEventListener('click', function (event) {
      if (results.hidden) return;
      if (event.target.closest('[data-search-panel]')) return;
      hide();
    });
  }

  /* =======================================================================
     Filtros y ordenacion (facetas nativas de Shopify)
     ======================================================================= */

  function initFacets() {
    var form = qs('[data-facets]');
    if (!form) return;

    var panel = qs('[data-facets-panel]', form);
    var toggle = qs('[data-facets-toggle]', form);

    if (panel && toggle) {
      // Progressive enhancement: el panel se renderiza visible (para que
      // funcione sin JavaScript) y aqui se pliega solo en movil, donde el
      // boton de filtros esta visible.
      var compact = window.matchMedia('(max-width: 1023px)');

      function applyLayout() {
        panel.hidden = compact.matches;
        toggle.setAttribute('aria-expanded', String(!compact.matches));
      }

      applyLayout();
      compact.addEventListener('change', applyLayout);

      toggle.addEventListener('click', function () {
        var willOpen = panel.hidden;
        panel.hidden = !willOpen;
        toggle.setAttribute('aria-expanded', String(willOpen));
      });
    }

    // Al cambiar un control se envia el formulario: Shopify devuelve la
    // coleccion ya filtrada. Sin logica de filtrado propia en el cliente.
    form.addEventListener('change', function (event) {
      if (!event.target.closest('[data-facet-control]')) return;
      form.submit();
    });
  }

  /* =======================================================================
     Seguimiento de pedido

     Shopify no expone ninguna busqueda de pedidos por numero en el escaparate,
     asi que aqui no se consulta nada: se compone la URL del servicio de
     rastreo que haya configurado el administrador y se abre. Si el campo esta
     vacio no se navega y se avisa; nunca se abre una pagina de rastreo con un
     numero en blanco.
     ======================================================================= */

  function initOrderTracking() {
    var form = qs('[data-order-track]');
    if (!form) return;

    var input = qs('[data-order-track-input]', form);
    var error = qs('[data-order-track-error]');
    var template = form.getAttribute('data-url');
    if (!input || !template) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var value = input.value.trim();

      if (!value) {
        if (error) {
          error.textContent = form.getAttribute('data-error') || '';
          error.hidden = false;
        }
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }

      if (error) error.hidden = true;
      input.removeAttribute('aria-invalid');

      // El numero puede contener caracteres que hay que escapar en la URL.
      var url = template.replace('{number}', encodeURIComponent(value));
      window.open(url, '_blank', 'noopener');
    });

    // Al escribir se retira el aviso: no se deja un error visible que ya no aplica.
    input.addEventListener('input', function () {
      if (error && !error.hidden) error.hidden = true;
      input.removeAttribute('aria-invalid');
    });
  }

  /* =======================================================================
     Direcciones de cliente — pais/provincia y confirmacion de borrado
     ======================================================================= */

  function initAddressForms(scope) {
    qsa('[data-address-country]', scope || document).forEach(function (countrySelect) {
      var provinceSelect = document.getElementById(countrySelect.getAttribute('data-province-target'));
      if (!provinceSelect) return;

      var wrapper = qs('[data-province-wrapper="' + provinceSelect.id + '"]');

      function syncProvinces() {
        var option = countrySelect.options[countrySelect.selectedIndex];
        var provinces = [];

        // Shopify incluye data-provinces en cada <option> de
        // all_country_option_tags. No hace falta shopify_common.js.
        try {
          provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
        } catch (error) {
          provinces = [];
        }

        provinceSelect.innerHTML = '';

        if (!provinces.length) {
          if (wrapper) wrapper.hidden = true;
          return;
        }

        if (wrapper) wrapper.hidden = false;
        var preselected = provinceSelect.getAttribute('data-default');

        provinces.forEach(function (province) {
          var opt = document.createElement('option');
          opt.value = province[0];
          opt.textContent = province[1];
          if (preselected && preselected === province[0]) opt.selected = true;
          provinceSelect.appendChild(opt);
        });
      }

      var defaultCountry = countrySelect.getAttribute('data-default');
      if (defaultCountry) countrySelect.value = defaultCountry;

      countrySelect.addEventListener('change', syncProvinces);
      syncProvinces();
    });
  }

  function initConfirmActions() {
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-confirm-message]');
      if (!trigger) return;

      if (!window.confirm(trigger.getAttribute('data-confirm-message'))) {
        event.preventDefault();
      }
    });
  }

  /* =======================================================================
     Estado de carga en formularios nativos (newsletter, contacto)
     ======================================================================= */

  function initFormLoading() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form.matches('[data-product-form]')) return;

      var button = form.querySelector('button[type="submit"]');
      if (button) button.classList.add('is-loading');
    });
  }

  /* =======================================================================
     Arranque
     ======================================================================= */

  function init() {
    initDrawerEvents();
    initNavDropdowns();
    initSearch();
    initCartEvents();
    initFormLoading();
    initConfirmActions();
    initOrderTracking();
    initHeroVideo();
    initProductGallery();
    initStickyAtc();
    initRecommendations();
    initPredictiveSearch();
    initFacets();
    initVariantSelectors();
    initAddressForms();
    initScrollReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme Editor: al recargar una seccion hay que reinicializar lo que vive
     dentro de ella. Sin esto, editar una seccion rompia el comportamiento. */
  document.addEventListener('shopify:section:load', function (event) {
    initHeroVideo();
    initProductGallery(event.target);
    initStickyAtc();
    initVariantSelectors(event.target);
    initAddressForms(event.target);
    initScrollReveal(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (Drawer.active && event.target.contains(Drawer.active)) {
      Drawer.close(Drawer.active);
    }
  });

  window.Cocinexa.cart = Cart;
  window.Cocinexa.drawer = Drawer;

  /* Carrito: se anuncia suscribiendose al evento que la logica del carrito ya
     emitia. No se ha modificado ni una linea de Cart.add ni de Cart.refresh,
     que estaban verificados. Cubre anadir, cambiar cantidad y eliminar. */
  document.addEventListener('cocinexa:cart:updated', function (event) {
    var cart = event.detail;
    if (!cart) return;
    announce(withCount(a11yStrings.cartCount, cart.item_count));
  });

})();
